import { render, staticRenderFns } from "./EventEdit.vue?vue&type=template&id=b5842210&"
import script from "./EventEdit.vue?vue&type=script&lang=js&"
export * from "./EventEdit.vue?vue&type=script&lang=js&"
import style0 from "./EventEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports